var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenphoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1821 0.182495C12.827 0.18299 15.139 1.96717 15.8095 4.52569C16.4799 7.08422 15.3399 9.77296 13.0349 11.07C10.7299 12.367 7.84 11.9457 6.00112 10.0447C7.64937 9.37803 8.72821 7.77794 8.72821 5.99996C8.72821 4.22202 7.64937 2.6219 6.00112 1.95525C7.08395 0.833224 8.5723 0.194864 10.1301 0.182669L10.1821 0.182495ZM0.894637 3.35283C2.08749 1.78965 4.17848 1.21737 6.00112 1.95525C3.81939 4.21042 3.81939 7.78953 6.00112 10.0447C4.17848 10.7826 2.08749 10.2103 0.894637 8.64712C-0.298212 7.0839 -0.298212 4.91601 0.894637 3.35283Z",
    fill: "#A6A9B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenphoneIcon);
export default __webpack_public_path__ + "static/media/openphone_icon.dc94ad3e8e1594475dde48f6f954c374.svg";
export { ForwardRef as ReactComponent };